<template>
  <!-- 交接异常工单 -->
  <div>
    <el-card class="mb5">
      <el-form>
        <el-row justify="left" style="flex-wrap: wrap; align-items: center" type="flex">
          <el-col :span="7">
            <el-form-item :label="$t('collectionCenter.RegistrationT')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('collectionCenter.EndTime')"
                :range-separator="$t('collectionCenter.to')"
                :start-placeholder="$t('collectionCenter.StartTime')"
                style="width: 90%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--运单号-->
            <el-form-item>
              <el-select v-model="numberType" style="width: 90%" @change="numberTypeChange">
                <el-option
                  key="1"
                  :label="$t('GlobalSetObj.waybillNumber')"
                  :value="0"
                /><!--运单号-->
                <el-option
                  key="2"
                  :label="$t('GlobalSetObj.ScanNumber')"
                  :value="1"
                /><!--扫描单号-->
                <el-option
                  key="3"
                  :label="$t('collectionCenter.workOrderNumber')"
                  :value="2"
                /><!--工单编号-->
              </el-select>
              <br>
              <el-input
                v-model="numberBox"
                :placeholder="$t('collectionCenter.BatchQuery')"
                :rows="1"
                style="width: 90%"
                type="textarea"
                @blur="numberBoxChange"
                @keydown.enter.native="numberBoxChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--搜索-->
            <el-button size="small" type="primary" @click="search">{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button size="small" @click="resetForm">{{ $t('newOrder.reset') }} </el-button>
            <!--高级搜索-->
            <el-button size="small" type="primary" @click="advancedSearch">{{ $t('home.advancedSearch') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- 已选条件（仅展示高级搜索内的条件） -->
      <div v-if="getSelectedConditions().length" class="selected-conditions">
        <span class="selected-label">
          <i class="el-icon-filter" />
          {{ $t('seller.selectedConditions') }}:
        </span>
        <el-tag
          v-for="item in getSelectedConditions()"
          :key="item.key"
          class="selected-tag"
          closable
          size="medium"
          @close="removeCondition(item.key)"
        >
          {{ item.label }}: {{ item.value }}
        </el-tag>
        <el-button class="clear-all-btn" type="text" @click="clearAllConditions">
          <i class="el-icon-delete" />
          {{ $t('seller.clearAll') }}
        </el-button>
      </div>
    </el-card>
    <el-card>
      <div>
        <el-button
          v-permit:remove="'btn:quality-service:handover-exception:bulkImport'"
          size="small"
          type="primary"
          @click="allImportOrder"
        >{{ $t('newOrder.bulkImport') }} </el-button><!--批量导入-->
        <el-button size="small" @click="download">{{ $t('collectionCenter.export') }} </el-button><!-- 导出 -->
        <el-button
          v-permit:remove="'btn:quality-service:handover-exception:modifyResult'"
          size="small"
          @click="editResult"
        >{{ $t('collectionCenter.modifyResult') }} </el-button><!-- 修改处理结果 -->
        <el-button
          v-permit:remove="'btn:quality-service:handover-exception:modifyResult'"
          size="small"
          @click="exportOrderNumberDetailsResult"
        >{{ $t('collectionCenter.exportOrderNumberDetails') }} </el-button><!-- 修改处理结果 -->
      </div>

      <!--  高级搜索  -->
      <searchCom ref="searchComRef" @child-search="childSearch" />

      <el-tabs v-model="ticketType" @tab-click="handleClick">
        <el-tab-pane :label="$t('collectionCenter.tudo')" name="all">
          <template slot="label">
            <div>{{ $t('collectionCenter.tudo') }} {{ statistics.allQuantity }}</div>
          </template>
        </el-tab-pane>
        <el-tab-pane
          :disabled="statistics.reportedQuantity === 0"
          :label="$t('collectionCenter.myReported') + ' ' + statistics.reportedQuantity"
          name="1"
        />
        <el-tab-pane
          :disabled="statistics.disposeQuantity === 0"
          :label="$t('collectionCenter.myPending') + ' ' + statistics.disposeQuantity"
          name="2"
        />
      </el-tabs>
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        max-height="600"
        row-key="id"
        style="width: 100%"
        @selection-change="selectionChange"
      >
        <el-table-column
          align="center" fixed="left" type="selection"
          width="50"
        />
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="55"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.align"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'ticketStatusName'">
              <!-- 1.待处理、2.处理中、3.部分结束、4.全部结束 -->
              <el-tag v-if="scope.row['ticketStatus'] === 1" type="success">{{ $t('GlobalSetObj.Pending') }}
              </el-tag>
              <el-tag v-else-if="scope.row['ticketStatus'] === 2">{{ $t('newOrder.processing') }}
              </el-tag>
              <el-tag v-else-if="scope.row['ticketStatus'] === 3" type="warning">{{ $t('collectionCenter.partiallyCompleted') }}
              </el-tag>
              <el-tag v-else-if="scope.row['ticketStatus'] === 4" type="danger">{{ $t('collectionCenter.fullyCompleted') }}
              </el-tag>
              <span v-else>--</span>
            </div>
            <div v-else-if="item.prop === 'detailSum'">
              <div
                v-if="scope.row['detailSum']"
                class="detailSum_class"
                @click="detailMsgClick(scope.row)"
              >
                {{ scope.row['detailSum'] }}
              </div>
              <span v-else>--</span>
            </div>
            <div v-else>
              <div>{{ scope.row[item.prop] || '--' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center" fixed="right" label="操作（Ação）"
          width="180"
        >
          <template slot-scope="scope">
            <div class="operation_class">
              <span
                v-permit:remove="'btn:quality-service:handover-exception:Reply'"
                @click="replyMessage(scope.row)"
              >
                <!--  回复  -->{{ $t('GlobalSetObj.Reply') }}
              </span>
              <span
                v-if="scope.row['ticketStatus'] !== 4 && scope.row['ticketType'] !== 1"
                v-permit:remove="'btn:quality-service:handover-exception:over'"
                @click="processRClick(scope.row)"
              >
                <!--  结束  -->{{ $t('collectionCenter.end') }}
              </span>
              <span @click="imageOpenClick(scope.row)">
                <!--  图片  -->{{ $t('collectionCenter.picture') }}
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="getPageSize"
        @current-change="handleCurrentChange"
      />
      <div style="height: 50px" />
    </el-card>

    <!-- 批量导入 -->
    <el-drawer
      :close-on-click-modal="false"
      :title="$t('basicData.BulkImport')"
      :visible.sync="bulkImportDialogVisible"
      :wrapper-closable="false"
      direction="ltr"
      size="600px"
      @close="bulkImportCloseDrawer"
    >
      <bulkImport
        ref="bulkImportRef"
        @bIClose="bulkImportCloseDrawer"
        @toSearch="handleCurrentChange"
      />
    </el-drawer>

    <!--回复弹窗-->
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="$t('collectionCenter.messageRecord')"
      :visible.sync="seeDialogVisible"
      class="drawerClass"
      direction="ltr"
      size="1000px"
      @close="closeDrawer"
    >
      <messageDetail ref="messageDetailRef" :reply-message-data="replyMessageData" />
    </el-drawer>

    <!--处理结果-->
    <el-dialog
      :before-close="processRClose"
      :title="$t('collectionCenter.processingResult')"
      :visible.sync="processRDialogVisible"
      width="30%"
    >
      <div style="font-size: 15px; font-weight: bold; color: #67696d">
        {{ $t('GlobalSetObj.totalOptions') }}：{{ processResultForm.ids.length }}
      </div>
      <el-form
        ref="processRFormRef"
        :model="processResultForm"
        label-position="top"
        style="margin: 10px"
      >
        <el-row>
          <el-col :span="24">
            <!-- 处理结果 -->
            <el-form-item
              :label="$t('collectionCenter.processingResult') + '：'"
              :rules="[
                { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
              ]"
              prop="handlingResult"
            >
              <el-select
                v-model="processResultForm.handlingResult"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in processResultList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="processRClose">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="processRSubmit">{{
          $t('GlobalSetObj.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <!--查看图片-->
    <el-dialog
      :before-close="imgClose"
      :title="$t('navbar.seeImage')"
      :visible.sync="imgDialogVisible"
      width="50%"
    >
      <el-row class="imgBox">
        <el-col
          v-for="(item, index) in srcList"
          :key="index"
          :span="7"
          style="margin-bottom: 10px; margin-right: 10px"
        >
          <el-image
            :preview-src-list="srcList" :src="item" fit="contain"
            style="width: 100%"
          />
        </el-col>
      </el-row>
    </el-dialog>

    <!--运单明细-->
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="$t('GlobalSetObj.DetailOfwaybill')"
      :visible.sync="waybillDetailVisible"
      direction="ltr"
      size="70%"
      @close="waybillDetailClose"
    >
      <waybillDetail ref="waybillDetailRef" :way-id="waybillId" />
    </el-drawer>
  </div>
</template>

<script>
import {
  handoverAbnormalityExport,
  handoverAbnormalityPage,
  handoverAbnormalityResults,
  handoverAbnormalityStatistics,
  handoverIdExport
} from '@/api/newExpressAPI';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { Loading } from 'element-ui';

export default {
  name: 'HandoverException',
  components: {
    searchCom: () => import('./component/searchCom.vue'),
    messageDetail: () => import('./component/messageDetail.vue'),
    bulkImport: () => import('./component/bulkImport.vue'),
    waybillDetail: () => import('./component/waybillDetail.vue')
  },
  data() {
    return {
      ticketType: 'all',
      timeValue: [],
      numberType: 0,
      numberBox: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          registrationStartTime: '',
          registrationEndTime: '',
          waybillNumberList: [], // 运单号
          scanNumberList: [], // 扫描单号
          ticketNumberList: [], // 工单编号
          handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
          handlingRegionList: [], // 处理大区
          handlingSiteList: [], // 处理网点
          reportRegionList: [], // 上报大区
          reportSiteList: [], // 上报网点
          registrationUserList: [], // 登记人
          endOperationPersonList: [], // 结束操作人
          ticketType: null,
          registrationSource: null // 登记来源,0快递系统,1服务商系统
        }
      },
      statistics: {}, // 统计数据
      total: 0,
      tableData: [],
      tableHeaderList: [
        {
          id: 1,
          label: '工单编号（Número do chamado）',
          prop: 'ticketNumber',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 2,
          label: '登记时间（Data de registro）',
          prop: 'createTime',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 3,
          label: '事件类型（Tipo de evento）',
          prop: 'eventTypeName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 4,
          label: '状态（Status）',
          prop: 'ticketStatusName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 5,
          label: '工单类型（Tipo do chamado）',
          prop: 'ticketTypeName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 6,
          label: '处理结果（Comentário de tratamento）',
          prop: 'handlingResultName',
          cloWidth: '180',
          align: 'center'
        },
        {
          id: 7,
          label: '处理大区（Região de tratamento）',
          prop: 'handlingRegionName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 8,
          label: '处理网点（Ponto de tratamento）',
          prop: 'handlingSiteName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 9,
          label: '相关运单数（Conhecimentos Relacionados）',
          prop: 'detailSum',
          cloWidth: '180',
          align: 'center'
        },
        {
          id: 10,
          label: '上报大区（Região de reporte）',
          prop: 'reportRegionName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 11,
          label: '上报网点（Ponto de reporte）',
          prop: 'reportSiteName',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 12,
          label: '描述（Descrição）',
          prop: 'description',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 13,
          label: '截止时间（Data de vencimento）',
          prop: 'deadlineTime',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 14,
          label: '是否有最新回复（Possui nova resposta?）',
          prop: 'latestReply',
          cloWidth: '200',
          align: 'center'
        },
        {
          id: 15,
          label: '最新回复时间（Data da última resposta）',
          prop: 'latestReplyTime',
          cloWidth: '200',
          align: 'center'
        },
        {
          id: 16,
          label: '最新回复内容（Último que respondeu）',
          prop: 'latestReplyContent1',
          cloWidth: '180',
          align: 'center'
        },
        {
          id: 17,
          label: '登记人（Pessoa que registrou）',
          prop: 'registrant',
          cloWidth: '150',
          align: 'center'
        },
        {
          id: 18,
          label: '结束操作时间（Hora de término da operação）',
          prop: 'endOperationTime',
          cloWidth: '180',
          align: 'center'
        },
        {
          id: 19,
          label: '结束操作人（Pessoa de término da operação）',
          prop: 'endTheOperator',
          cloWidth: '180',
          align: 'center'
        }
      ],
      selectData: [],

      // 回复弹窗
      seeDialogVisible: false,
      replyMessageData: null,
      // 处理结果
      processRDialogVisible: false,
      processResultForm: {
        ids: [],
        handlingResult: null,
        operateType: null
      },
      processResultList: [
        { id: 1, name: this.$t('collectionCenter.upstreamResponsibility') }, // 上游责任
        { id: 2, name: this.$t('collectionCenter.downstreamResponsibility') }, // 下游责任
        { id: 3, name: this.$t('GlobalSetObj.blameless') } // 无责
      ],
      // 查看图片
      imgDialogVisible: false,
      srcList: [],
      // 批量导入
      bulkImportDialogVisible: false,

      // 运单明细
      waybillDetailVisible: false,
      waybillId: null
    };
  },
  created() {
    this.resetForm();
    this.getStatistics();
  },
  methods: {
    getStatistics() {
      handoverAbnormalityStatistics(this.queryForm.params).then((res) => {
        if (res.code === 200) {
          this.statistics = res.data;
        }
      });
    },
    handleClick() {
      this.queryForm.params.ticketType = this.ticketType === 'all' ? null : Number(this.ticketType);
      this.selectData = [];
      this.queryForm.pageNumber = 1;
      this.handleCurrentChange();
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.registrationStartTime = '';
        this.queryForm.params.registrationEndTime = '';
        return;
      }
      this.timeValue = [val[0], val[1]];
      this.queryForm.params.registrationStartTime = val[0];
      this.queryForm.params.registrationEndTime = val[1];
      if (val[1]) {
        const endTime = dayjs(val[0]).subtract(-1, 'year').format('YYYY-MM-DD') + ' 23:59:59';
        if (val[1] > endTime) {
          this.$message({
            // 最多可查询到一年的数据
            message: this.$t('collectionCenter.moreYear'),
            type: 'warning'
          });
          const d = new Date();
          const today = dayjs(d).format('YYYY-MM-DD');
          const threeDaysAgo = dayjs(d).subtract(2, 'day').format('YYYY-MM-DD');
          this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
          this.queryForm.params.registrationStartTime = threeDaysAgo + ' 00:00:00';
          this.queryForm.params.registrationEndTime = today + ' 23:59:59';
        }
      }
    },
    numberTypeChange() {
      this.numberBox = '';
      this.queryForm.params.waybillNumberList = [];
      this.queryForm.params.scanNumberList = [];
      this.queryForm.params.ticketNumberList = [];
    },
    numberBoxChange() {
      if (this.numberBox) {
        let lines = this.numberBox
          .split('\n')
          .filter((line) => line && line.trim())
          .map((line) => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.numberBox = lines.join('\n');
        if (this.numberType === 0) {
          this.queryForm.params.waybillNumberList = this.numberBox.split('\n');
        } else if (this.numberType === 1) {
          this.queryForm.params.scanNumberList = this.numberBox.split('\n');
        } else if (this.numberType === 2) {
          this.queryForm.params.ticketNumberList = this.numberBox.split('\n');
        }
      } else {
        this.numberBox = '';
        this.queryForm.params.waybillNumberList = [];
        this.queryForm.params.scanNumberList = [];
        this.queryForm.params.ticketNumberList = [];
      }
    },
    search() {
      if (!this.numberBox && (!this.timeValue || this.timeValue.length <= 0)) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      this.ticketType = 'all';
      this.queryForm.params.ticketType = null;
      this.getStatistics();
      this.selectData = [];
      this.queryForm.pageNumber = 1;
      this.handleCurrentChange();
    },
    // 分页
    getPageSize(newSize) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = newSize;
      this.handleCurrentChange();
    },
    handleCurrentChange(newPage) {
      if (newPage !== undefined && newPage !== null) {
        this.queryForm.pageNumber = newPage;
      }
      const loading = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      handoverAbnormalityPage(this.queryForm)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records.map((arr) => {
              const latestReplyContent1 = arr.latestReplyContent
                ? this.removeHtml(arr.latestReplyContent)
                : '';
              return {
                latestReplyContent1,
                ...arr
              };
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    removeHtml(html) {
      return html ? html.replace(/<[^>]*>/g, '') : '';
    },
    resetForm() {
      const today = dayjs().format('YYYY-MM-DD');
      const threeDaysAgo = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
      this.numberBox = '';
      this.numberType = 0;
      this.queryForm.params = {
        registrationStartTime: threeDaysAgo + ' 00:00:00',
        registrationEndTime: today + ' 23:59:59',
        waybillNumberList: [],
        scanNumberList: [], // 扫描单号
        ticketNumberList: [], // 工单编号
        handlingResult: null, // 处理结果 1.上游责任、2.下游责任、3.无责、4.超时未回复
        handlingRegionList: [], // 处理大区
        handlingSiteList: [], // 处理网点
        reportRegionList: [], // 上报大区
        reportSiteList: [], // 上报网点
        registrationUserList: [], // 登记人
        endOperationPersonList: [], // 结束操作人
        ticketType: null,
        registrationSource: null // 登记来源,0快递系统,1服务商系统
      };
      this.ticketType = 'all';
      this.search();
      this.$nextTick(() => {
        if (this.$refs.searchComRef) {
          this.$refs.searchComRef.resetForm();
        }
      });
    },
    // 高级搜索
    advancedSearch() {
      this.$refs.searchComRef.showDialog();
    },
    childSearch(form) {
      this.queryForm.params.handlingResult = form.handlingResult;
      this.queryForm.params.handlingRegionList = form.handlingRegionList;
      this.queryForm.params.handlingSiteList = form.handlingSiteList;
      this.queryForm.params.reportRegionList = form.reportRegionList;
      this.queryForm.params.reportSiteList = form.reportSiteList;
      this.queryForm.params.registrationUserList = form.registrationUserList;
      this.queryForm.params.endOperationPersonList = form.endOperationPersonList;
      this.queryForm.params.registrationSource = form.registrationSource;
      this.search();
    },
    // 大区 id -> 名称（取自高级搜索组件已加载的大区数据）
    getRegionName(id) {
      const ref = this.$refs.searchComRef;
      if (!ref) return id;
      const pools = [...(ref.regionList || []), ...(ref.regionList2 || [])];
      const region = pools.find((item) => item.id === id);
      return region ? `${region.zhName}（${region.puName}）` : id;
    },
    // 网点 id -> 名称
    getSiteName(id) {
      const ref = this.$refs.searchComRef;
      if (!ref) return id;
      const regionPools = [...(ref.regionList || []), ...(ref.regionList2 || [])];
      for (let i = 0; i < regionPools.length; i++) {
        const site = (regionPools[i].sites || []).find((item) => item.id === id);
        if (site) return site.name;
      }
      const sitePools = [...(ref.siteList || []), ...(ref.siteList2 || [])];
      const fallback = sitePools.find((item) => item.id === id);
      return fallback ? fallback.name : id;
    },
    // 用户 id -> 名称
    getUserName(id) {
      const ref = this.$refs.searchComRef;
      if (!ref) return id;
      const pools = [...(ref.registerList || []), ...(ref.registrationList || [])];
      const user = pools.find((item) => item.id === id);
      return user ? user.username : id;
    },
    // 已选条件展示数据（仅展示高级搜索抽屉内的条件）
    getSelectedConditions() {
      const list = [];
      const p = this.queryForm.params;

      // 处理结果
      if (p.handlingResult !== null && p.handlingResult !== undefined) {
        const map = {
          1: this.$t('collectionCenter.upstreamResponsibility'),
          2: this.$t('collectionCenter.downstreamResponsibility'),
          5: this.$t('collectionCenter.partialResponsibility'),
          3: this.$t('GlobalSetObj.blameless'),
          4: this.$t('home.moreTimeNotReply')
        };
        list.push({
          key: 'handlingResult',
          label: this.$t('collectionCenter.processingResult'),
          value: map[p.handlingResult] !== undefined ? map[p.handlingResult] : p.handlingResult
        });
      }

      // 处理大区
      if (p.handlingRegionList && p.handlingRegionList.length) {
        list.push({
          key: 'handlingRegionList',
          label: this.$t('collectionCenter.processingRegion'),
          value: p.handlingRegionList.map((id) => this.getRegionName(id)).join(', ')
        });
      }

      // 处理网点
      if (p.handlingSiteList && p.handlingSiteList.length) {
        list.push({
          key: 'handlingSiteList',
          label: this.$t('collectionCenter.processingBranch'),
          value: p.handlingSiteList.map((id) => this.getSiteName(id)).join(', ')
        });
      }

      // 上报大区
      if (p.reportRegionList && p.reportRegionList.length) {
        list.push({
          key: 'reportRegionList',
          label: this.$t('fixDutyFine.reportingRegion'),
          value: p.reportRegionList.map((id) => this.getRegionName(id)).join(', ')
        });
      }

      // 上报网点
      if (p.reportSiteList && p.reportSiteList.length) {
        list.push({
          key: 'reportSiteList',
          label: this.$t('collectionCenter.reportingBranch'),
          value: p.reportSiteList.map((id) => this.getSiteName(id)).join(', ')
        });
      }

      // 登记来源
      if (p.registrationSource !== null && p.registrationSource !== undefined) {
        list.push({
          key: 'registrationSource',
          label: this.$t('collectionCenter.registrationSource'),
          value:
            p.registrationSource === 0
              ? this.$t('customerManagements.expressSystem')
              : this.$t('customerManagements.providerSystem')
        });
      }

      // 登记人
      if (p.registrationUserList && p.registrationUserList.length) {
        list.push({
          key: 'registrationUserList',
          label: this.$t('collectionCenter.registrar'),
          value: p.registrationUserList.map((id) => this.getUserName(id)).join(', ')
        });
      }

      // 结束操作人
      if (p.endOperationPersonList && p.endOperationPersonList.length) {
        list.push({
          key: 'endOperationPersonList',
          label: this.$t('collectionCenter.endOperator'),
          value: p.endOperationPersonList.map((id) => this.getUserName(id)).join(', ')
        });
      }

      return list;
    },
    // 移除单个已选条件
    removeCondition(key) {
      const resetValue = key === 'handlingResult' || key === 'registrationSource' ? null : [];
      this.queryForm.params[key] = resetValue;
      // 同步清理高级搜索抽屉内的条件，避免再次搜索时被回填
      const ref = this.$refs.searchComRef;
      if (ref && ref.searchParams) {
        ref.searchParams[key] = resetValue;
      }
      this.search();
    },
    // 清空全部已选条件（仅清空高级搜索内的条件）
    clearAllConditions() {
      this.resetForm();
    },
    /**
     * 批量导入-------------start
     */
    allImportOrder() {
      this.bulkImportDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.bulkImportRef.bulkImportOpen();
      });
    },
    bulkImportCloseDrawer() {
      this.bulkImportDialogVisible = false;
    },
    /**
     * 批量导入-------------end
     */

    /**
     * 运单详情-------------start
     */
    detailMsgClick(row) {
      this.waybillId = row;
      this.waybillDetailVisible = true;
      this.$nextTick(() => {
        if (this.$refs.waybillDetailRef) {
          this.$refs.waybillDetailRef.waybillSearch();
        }
      });
    },

    // 明细
    waybillDetailClose() {
      this.waybillDetailVisible = false;
      this.search();
    },
    /**
     * 运单详情-------------end
     */

    /**
     * 回复弹窗-------------start
     */
    // 点击回复弹框
    replyMessage(row) {
      this.seeDialogVisible = true;
      this.replyMessageData = row;
      this.$nextTick(() => {
        this.$refs.messageDetailRef.getMessageData();
      });
    },
    closeDrawer() {
      clearInterval(this.$refs.messageDetailRef.getIntervalMsg);
      this.search();
    },
    /**
     * 回复弹窗-------------end
     */

    /**
     * 处理结果-------------start
     */
    processRClick(row) {
      this.processRDialogVisible = true;
      this.processResultForm.ids = [row.id];
      this.processResultForm.operateType = 2;
    },
    processRClose() {
      this.processRDialogVisible = false;
      this.processResultForm.handlingResult = null;
      this.processResultForm.operateType = null;
      this.$refs.processRFormRef.clearValidate();
    },
    processRSubmit() {
      this.$refs.processRFormRef.validate((valid) => {
        if (valid) {
          handoverAbnormalityResults(this.processResultForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
              this.processRClose();
              this.search();
            }
          });
        } else {
          // 校验失败提示
          return false;
        }
      });
    },
    /**
     * 处理结果-------------end
     */

    /**
     * 查看图片-------------start
     */
    imageOpenClick(row) {
      this.imgDialogVisible = true;
      this.srcList = row.ticketPictureList;
    },
    imgClose() {
      this.imgDialogVisible = false;
      this.srcList = [];
    },
    /**
     * 查看图片-------------end
     */
    // 勾选
    selectionChange(select) {
      this.selectData = select;
    },
    // 导出
    download() {
      handoverAbnormalityExport(this.queryForm.params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 修改处理结果
    editResult() {
      if (this.selectData.length <= 0) {
        this.$message.warning(this.$t('collectionCenter.checkMsg')); // '请勾选数据'
        return;
      }
      // 过滤
      const validData = this.selectData.filter((item) => {
        return item.ticketStatus === 4 && item.ticketType === 2;
      });
      if (validData.length === 0) {
        this.$message.warning(this.$t('collectionCenter.modifyPermission'));
        return;
      }
      if (validData.length < this.selectData.length) {
        const filteredCount = this.selectData.length - validData.length;
        this.$message.warning(
          `${this.$t('collectionCenter.filteredInvalidData1')}${filteredCount}${this.$t(
            'collectionCenter.filteredInvalidData2'
          )}`
        );
        this.$nextTick(() => {
          this.$refs.tableRef.clearSelection();
          validData.forEach((row) => {
            this.$refs.tableRef.toggleRowSelection(row, true);
          });
        });
      }

      const idList = validData.map((arr) => {
        return arr.id;
      });
      this.processRDialogVisible = true;
      this.processResultForm.ids = idList;
      this.processResultForm.operateType = 1;
    },
    // 导出单号明细
    exportOrderNumberDetailsResult() {
      if (this.selectData.length <= 0) {
        this.$message.warning(this.$t('collectionCenter.checkMsg')); // '请勾选数据'
        return;
      }
      const idList = this.selectData.map((arr) => {
        return arr.id;
      });
      const dto = {
        ticketIds: idList
      };
      handoverIdExport(dto)
        .then((res) => {
          if (res.status === 'OK') {
            this.$refs.tableRef.clearSelection();
            const h = this.$createElement;
            this.$msgbox({
              // 提示
              title: this.$t('collectionCenter.tips'),
              message: h('p', null, [
                // '导出成功，数据将会在1~10分钟内生成表格，请到技术支持中心的资源任务列表中下载，'
                h('span', this.$t('collectionCenter.exportStatusNotification')),
                // 请勿重复导出!
                h('span', { style: 'color: red' }, this.$t('collectionCenter.notRepeatTheExport'))
              ]),
              showCancelButton: true,
              // 立即前往
              confirmButtonText: this.$t('collectionCenter.Immediately'),
              // 关闭
              cancelButtonText: this.$t('collectionCenter.close')
            })
              .then((action) => {
                if (action === 'confirm') {
                  this.$router.push({ name: 'exportTaskList' });
                }
              })
              .catch(() => {});
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box {
  padding: 20px;
  box-sizing: border-box;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Box ::v-deep .el-divider--horizontal {
  margin-top: 5px !important;
}

.operation_class {
  color: #4aa3ff;
  display: flex;
  justify-content: space-around;
  align-items: center;

  span {
    cursor: pointer;
    white-space: nowrap;
  }
}

.drawerClass ::v-deep .el-drawer__body {
  overflow-y: auto;
}

.imgBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.detailSum_class {
  color: #2392ff;
  cursor: pointer;
}

.selected-conditions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  clear: both;
  width: 100%;
  padding: 5px 0;
  gap: 8px;
  margin-top: -10px;
}

.selected-conditions .selected-label {
  font-weight: bold;
  color: #303133;
  margin-right: 4px;
}

.selected-conditions .selected-tag {
  background: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
}

.selected-conditions .clear-all-btn {
  margin-left: auto;
  color: #67c23a;
}

.selected-conditions .clear-all-btn:hover {
  color: #85ce61;
}
</style>
